<template>
  <a v-if="hasSlideAccess && slidesUrl" :href="slidesUrl" :class="align" download>
    <img :src="pdfIcon" alt="PDF" title="Click to download slides" />
  </a>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(`Slides: ${msg}`); // eslint-disable-line
const props = defineProps(["name", "year", "align"]); // eslint-disable-line
import {computed, shallowRef} from "vue";
import pdfIcon from "@/assets/img/pdf.svg";
import {useRoute} from "vue-router";
import useIsSignedIn from "@/composables/useIsSignedIn";
let slidesUrl = shallowRef();
const route = useRoute();
log(`props.year = ${props.year}`);
// const year = computed(() => {
//   if (props?.year) return props.year; // e.g., when called in /videos
//   if (props?.name && route.params.year) return route.params.year;
//   return "";
// });
const year = computed(() => {
  let output = "";
  if (route.params.year) output = route.params.year; // e.g., when called in /program
  if (props?.year) output = props.year; // e.g., when called in /videos
  log(`output = ${output}`);
  return output;
});

// Compute array of allowed event names
const allowedEvents = computed(() => {
  return year.value ? [`VIZBI ${year.value}`, `Masterclass ${year.value}`] : [];
});

// Compute access permission using isSignedIn
const hasSlideAccess = computed(() => {
  return useIsSignedIn(allowedEvents.value);
});

try {
  if (year.value) {
    let slides = `assets/years/${year.value}/People/slides/${props.name}.pdf`;
    let fallback = `assets/years/${year.value}/People/slides/masterclass/${props.name}.pdf`;
    try {
      slides = slides.replace(/ /g, "_");
      slidesUrl.value = require(`@/${slides}`).default;
      log(`slides = ${slides}`);
    } catch {
      fallback = fallback.replace(/ /g, "_");
      slidesUrl.value = require(`@/${fallback}`).default;
      log(`fallback slides = ${fallback}`);
    }
  }
} catch (error) {
  log(`Slides.vue|${year.value} file not found: ${error}`);
}
</script>

<style scoped>
img {
  height: 14px;
  vertical-align: middle; /* Vertically align with text */
}
.narrow img {
  height: 13px;
}
a {
  margin-left: 0.5em;
}
a.left {
  margin-left: 0em;
  margin-right: 0.5em;
}
</style>
